import React, { Component } from "react";
import { Modal } from 'antd';
import InputUploadFile from "../../form/input-with-label/InputUploadFile";

interface Props {
    handleCancel?: any;
    handleImport?: any;
    extensionsAllow?: any;
    value?: string;
    visible: boolean;
    loading?: boolean;
    title?: string;
    onChange?: any;
    error? : string;
    onchangeFileUpload?: any;
    filename?: string;
    accept?: string;
    label?: string;
}
interface State {
    visible: boolean;
}

export default class ModalUploadFile extends Component<Props, State> {
    render() {
        return (
            <div>
                <Modal
                    title={'Tải file hồ sơ'}
                    visible={this.props.visible}
                    onOk={this.props.handleImport}
                    onCancel={this.props.handleCancel}
                    destroyOnClose={true}
                    okText="Tải lên"
                    cancelText="Đóng"
                    className="modal-xs"
                    width="40%"
                    closable={false}
                >
                    <InputUploadFile
                        name="file1"
                        classWrapped="col-md-12 overflow-hidden"
                        label={this.props.label ? this.props.label :"Tải hồ sơ (Chỉ chấp nhận file zip, rar)"}
                        filename={this.props.filename}
                        onChanageFileUpload={this.props.onchangeFileUpload}
                        isRequired={true}
                        error={this.props.error}
                        extentionsAllow={this.props.extensionsAllow ? this.props.extensionsAllow : ['rar', 'zip']}
                        accept={this.props.accept ? this.props.accept : ".zip,.rar"}
                    />
                </Modal>
            </div>
        );
    }
}
